import React from 'react';
import HelpArticle from '../../components/help/HelpArticle';

const PaymentProblems: React.FC = () => {
  const content = (
    <>
      <h2>Betalingsproblemer</h2>
      <p>
        Løsninger til almindelige betalingsudfordringer mellem lejere og ejere.
      </p>

      <h3>Almindelige betalingsproblemer</h3>
      <p>
        Her er de mest typiske situationer og hvordan du løser dem:
      </p>

      <h3>Problem 1: Lejer har ikke betalt</h3>

      <h4>Som ejer - hvad gør du?</h4>
      <p>
        <strong>Før udlevering af værktøj:</strong>
      </p>
      <ul>
        <li>Udlevér simpelthen ikke værktøjet før betaling er modtaget</li>
        <li>Vær høflig men bestemt</li>
        <li>Foreslå alternative betalingsmetoder hvis der er tekniske problemer</li>
      </ul>

      <p>
        <strong>Efter udlevering (du glemte at få betaling):</strong>
      </p>
      <ol>
        <li>Send en venlig påmindelse via DoMore chat</li>
        <li>Giv en frist (f.eks. 24 timer)</li>
        <li>Hvis ingen respons, send en mere direkte besked</li>
        <li>Dokumentér al kommunikation</li>
        <li>Kontakt DoMore support efter 48 timer uden svar</li>
      </ol>

      <h4>Besked eksempel</h4>
      <blockquote>
        "Hej [Navn], jeg har bemærket at jeg endnu ikke har modtaget betaling for lejen af [værktøj]. Vil du venligst sende [beløb] DKK via [betalingsmetode] inden [dato]? Tak!"
      </blockquote>

      <h3>Problem 2: Betalingen fejlede teknisk</h3>

      <h4>MobilePay virker ikke</h4>
      <p>
        Mulige årsager og løsninger:
      </p>
      <ul>
        <li><strong>Appen er nede:</strong> Prøv bankoverførsel i stedet</li>
        <li><strong>Beløbsgrænse:</strong> Opdel betalingen i to transaktioner</li>
        <li><strong>Forkert nummer:</strong> Dobbelttjek modtagerens nummer</li>
        <li><strong>Ikke nok saldo:</strong> Overfør penge til MobilePay først</li>
      </ul>

      <h4>Bankoverførsel forsinket</h4>
      <p>
        Hvis overførsel ikke dukker op:
      </p>
      <ul>
        <li>Tjek at kontonummer er korrekt</li>
        <li>Bankoverførsler kan tage 1-2 hverdage</li>
        <li>Vis ejer kvittering for overførsel mens I venter</li>
        <li>Vurder om ejer vil acceptere dette</li>
      </ul>

      <h3>Problem 3: Uenighed om pris</h3>

      <h4>Ejeren kræver mere end aftalt</h4>
      <p>
        Hvis prisen pludselig er højere:
      </p>
      <ol>
        <li>Vis ejeren booking-bekræftelsen i DoMore</li>
        <li>Screenshot af aftalt pris</li>
        <li>Forklar at I havde en aftale</li>
        <li>Tilbyd kun at betale den aftalte pris</li>
        <li>Kontakt DoMore support hvis ejer insisterer</li>
      </ol>

      <h4>Lejer vil betale mindre en aftalt</h4>
      <p>
        Hvis lejer prøver at forhandle på sidste øjeblik:
      </p>
      <ol>
        <li>Vis booking-detaljer fra DoMore</li>
        <li>Vær høflig men fast: "Dette var prisen vi aftalte"</li>
        <li>Hvis de nægter, udlevér ikke værktøjet</li>
        <li>Rapportér til DoMore</li>
      </ol>

      <h3>Problem 4: Depositum tvister</h3>

      <h4>Ejer vil ikke returnere depositum</h4>
      <p>
        <strong>Trin 1: Forstå hvorfor</strong>
      </p>
      <ul>
        <li>Spørg ejeren specifikt hvad problemet er</li>
        <li>Bed om dokumentation (billeder af skader)</li>
        <li>Sammenlign med dine billeder fra afhentning</li>
      </ul>

      <p>
        <strong>Trin 2: Dokumentér din side</strong>
      </p>
      <ul>
        <li>Find dine billeder fra afhentning og returnering</li>
        <li>Revisér jeres chat omkring depositum</li>
        <li>Noter hvad I præcist aftalte</li>
      </ul>

      <p>
        <strong>Trin 3: Forhandl</strong>
      </p>
      <ul>
        <li>Hvis der ER skade du ikke så, vurder om det er rimeligt</li>
        <li>Foreslå delvist depositum retur hvis relevant</li>
        <li>Vær villig til at nå til kompromis</li>
      </ul>

      <p>
        <strong>Trin 4: Eskalér</strong>
      </p>
      <ul>
        <li>Hvis I ikke kan blive enige, kontakt DoMore support</li>
        <li>Del al dokumentation</li>
        <li>Bed om mægling</li>
      </ul>

      <h4>Lejer ødelægge værktøj men kræver depositum retur</h4>
      <p>
        <strong>Som ejer:</strong>
      </p>
      <ol>
        <li>Dokumentér skaden grundigt med billeder</li>
        <li>Sammenlign med tilstand ved udlevering</li>
        <li>Forklar lejeren hvad skaden koster at reparere</li>
        <li>Vær rimelig - kun hold hvad der er nødvendigt</li>
        <li>Giv kvittering for hvad du holder og hvorfor</li>
      </ol>

      <h3>Problem 5: Betaling efter returnering</h3>

      <h4>Lejer lovede at betale senere men gør det ikke</h4>
      <p>
        <strong>Forebyggelse:</strong> Få ALTID betaling før eller ved afhentning!
      </p>

      <p>
        <strong>Hvis det allerede er sket:</strong>
      </p>
      <ol>
        <li>Send påmindelse med bevis for aftalen</li>
        <li>Vær vedvarende men professionel</li>
        <li>Sæt klar frist</li>
        <li>Rapporter til DoMore efter frist</li>
        <li>Overvej inkasso ved store beløb</li>
        <li>Efterlad ærlig anmeldelse som advarsel til andre</li>
      </ol>

      <h3>Problem 6: Betalt forkert beløb</h3>

      <h4>Lejer betalte for meget</h4>
      <p>
        <strong>Som ejer:</strong>
      </p>
      <ul>
        <li>Returner overskuddet omgående</li>
        <li>Vær ærlig - det opbygger tillid</li>
        <li>Brug samme betalingsmetode</li>
      </ul>

      <h4>Lejer betalte for lidt</h4>
      <p>
        <strong>Som ejer:</strong>
      </p>
      <ul>
        <li>Informér lejeren venligt</li>
        <li>Vis den manglende forskel</li>
        <li>Bed om resten før udlevering</li>
      </ul>

      <h3>Problem 7: Forkert betalingsmodtager</h3>

      <h4>Sendt til forkert MobilePay nummer</h4>
      <p>
        Hvis lejer sendte til forkert nummer:
      </p>
      <ol>
        <li>Kontakt MobilePay kundeservice så hurtigt som muligt</li>
        <li>Forklar situationen</li>
        <li>Der er begrænset der kan gøres hvis modtager ikke vil returnere</li>
        <li>Dokumentér for DoMore support</li>
        <li>Ejer må beslutte om de vil udlevere alligevel</li>
      </ol>

      <h3>Problem 8: Svindel mistanke</h3>

      <h4>Tegn på svindel</h4>
      <ul>
        <li>Personen presser på for øjeblikkelig betaling</li>
        <li>Prisen ændres konstant</li>
        <li>De vil ikke dokumentere betaling</li>
        <li>Undgår at mødes personligt</li>
        <li>Profilen ser falsk ud</li>
      </ul>

      <h4>Hvad gør du?</h4>
      <ol>
        <li>Stop transaktionen med det samme</li>
        <li>Afbryd bookingen</li>
        <li>Rapportér brugeren til DoMore</li>
        <li>Del al dokumentation</li>
        <li>Advars andre i din anmeldelse</li>
      </ol>

      <h3>Problem 9: Valutaproblemer</h3>

      <h4>International betaling</h4>
      <p>
        Hvis lejer/ejer er fra et andet land:
      </p>
      <ul>
        <li>Aftal valuta og kurs på forhånd</li>
        <li>Vær opmærksom på konverteringsgebyr</li>
        <li>Overvej Wise/Revolut for bedre kurser</li>
        <li>Dokumentér hvilken valuta I handler i</li>
      </ul>

      <h3>DoMore Support kan hjælpe</h3>
      <p>
        Kontakt os når:
      </p>
      <ul>
        <li>Den anden part ikke svarer</li>
        <li>Der er uenighed om facts</li>
        <li>Du har mistanke om svindel</li>
        <li>Du har forsøgt at løse det selv uden held</li>
      </ul>

      <h3>Hvad vi har brug for</h3>
      <p>
        Når du kontakter support, medgiv:
      </p>
      <ul>
        <li>Booking ID fra DoMore</li>
        <li>Screenshots af relevante beskeder</li>
        <li>Bevis for betaling (eller mangel på samme)</li>
        <li>Billeder hvis relevant</li>
        <li>Klar beskrivelse af problemet</li>
        <li>Hvad du allerede har forsøgt</li>
      </ul>

      <h3>Hvad vi ikke kan gøre</h3>
      <p>
        DoMore support kan ikke:
      </p>
      <ul>
        <li>Fremtvinge betaling fra brugere</li>
        <li>Refundere dig med DoMore's midler</li>
        <li>Fungere som bank eller politi</li>
        <li>Garantere udfald i tvister</li>
      </ul>

      <p>
        Men vi kan:
      </p>
      <ul>
        <li>Mægle mellem parter</li>
        <li>Vurdere sagforhold objektiøst</li>
        <li>Advare eller bandlyse problematiske brugere</li>
        <li>Vejlede om næste skridt</li>
      </ul>

      <h3>Undgå problemer fra starten</h3>
      <p>
        Forebyg betalingsproblemer ved at:
      </p>
      <ul>
        <li>Aftal betalingsmetode skriftligt i DoMore chat</li>
        <li>Bekræft pris før mødet</li>
        <li>Betal kun den aftalte pris</li>
        <li>Få betaling før udlevering</li>
        <li>Dokumentér alt</li>
        <li>Tjek ratings før booking</li>
        <li>Kommunikér klart</li>
        <li>Vær pålidelig og ærlig</li>
      </ul>
    </>
  );

  return (
    <HelpArticle
      title="Betalingsproblemer"
      category="Betaling"
      content={content}
      relatedArticles={[
        { title: 'Håndtér betalinger', link: '/help/payment-management' },
        { title: 'Sikker betaling', link: '/help/secure-payment' },
        { title: 'Tvister og support', link: '/help/dispute-support' },
      ]}
    />
  );
};

export default PaymentProblems;
